import React from 'react'
import SelectQuantity from '../SelectQuantity'
import './styles.css'
import ChangeIncrementSvg from '../ChangeIncrementSvg'

const UpdateAppointmentCard = ({ appointment, color = '#333', handleSetView, updateQuantity, quantity, originalQty, canCancel }) => {
  const { title = '', duration = '', image = '', price = '' } = appointment
  return (
    <div className="ct-modal__confirm-card">
      <div className="ct-modal__confirm-card--image">
        <img src={appointment.image} alt=""/>
      </div>
      <div className="ct-modal__confirm-card--content">
        <div className="ct-modal__confirm-card--heading--container">
          <span className="ct-modal__confirm-card--heading">{title}</span>
        </div>
        <div className="ct-modal__quantity--select__change" style={{justifyContent: 'flex-start'}}>
          <ChangeIncrementSvg disabled={!canCancel || Boolean(Number(quantity) <= 1)} icon="minus" color="#fd6a4f" width="20px" updateQuantity={updateQuantity} />
            <input type="number" value={Number(quantity)} disabled onChange={(e) => updateQuantity(e.target.value) } />
          <ChangeIncrementSvg disabled={Boolean(Number(quantity) >= originalQty)} icon="plus" color="#fd6a4f" width="20px" updateQuantity={updateQuantity} />
        </div>
      </div>
      {/* <div className="ct-modal__confirm-card--quantity-container">
        <span className="ct-modal__confirm-card--quantity">Quantity: {quantity}</span>
      </div> */}
      <div className="ct-modal__confirm-card--price-container">
        <span className="ct-modal__confirm-card--price">${Number(appointment.price * Number(quantity)).toFixed(2)}</span>
      </div>
    </div>
  )
}

export default UpdateAppointmentCard
